// src/pages/WebDesignDevelopment.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import GetInTouch from '../components/GetInTouch';

import { useImageParallax } from "../hooks/useImageParallax";

import web from '../assets/images/services/web.webp';

const WebDesignDevelopment: React.FC = () => {


const seo = seoConfig.webDesignDevelopment; // ✅ Load meta for this page

useImageParallax(".anim-image-parallax"); // hook call


  return (


<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />




  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-web bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Web Design & Development</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}

  {/* rts about area three */}
  <div
    className="rts-about-area parallax-about pt_sm--0 pb--80"
    id="about"
  >
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-5">
          <a href="about.html" className="pli-image-link">
            <div className="pli-image-holder">
              {/* Use class "cover-opacity-*" to set image overlay if needed. For example "cover-opacity-2". Useful if class "pli-info-overlay" is enabled on "portfolio-list". Note: It is individual and depends on the image you use. More info about helper classes in file "helper.css". */}
              <figure className="pli-image">
                <img
                  className="anim-image-parallax tt-lazy"
                  src={web}
                  data-src={web}
                  alt="image"
                />
              </figure>{" "}
              {/* /.pli-image */}
            </div>{" "}
            {/* /.pli-image-holder */}
          </a>{" "}
          {/* /.pli-image-link */}
        </div>
        <div className="col-lg-7">

  <div className="content-wrapper">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Your Vision, Our Web Expertise
    </h2>
    <p className="disc">
      At  <strong>Manikarn Digital</strong>, we craft stunning, high-performance websites that not only look exceptional but are also strategically designed to drive results. Our approach blends user-centric design with technical excellence, empowering businesses to make a lasting impression online.
    </p>
    <Link to="/contact" className="learn-more-btn mt--30">
      Contact Us <i className="fa-solid fa-arrow-up-right-from-square"></i>
    </Link>
  </div>


        </div>
      </div>
    </div>
  </div>
  {/* rts about area three end */}



    {/* service area start */}
  <div className="rts-servicearea-start pt_sm--0 pb--100 pb_sm--20">
    <div className="container">
      <div className="row mb--10">
        <div className="col-lg-10 mx-auto">

  <div className="content-wrapper text-center">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Comprehensive Web Design & Development Solutions
    </h2>
  </div>


        </div>
      </div>
      <div className="row g-2">
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

<svg
  width="120"
  height="80"
  viewBox="0 0 150 100"
  xmlns="http://www.w3.org/2000/svg"
>
  {/* Laptop / Desktop */}
  <rect
    x="10"
    y="20"
    width="70"
    height="50"
    rx="8"
    fill="transparent"
    stroke="#ffffff"
    strokeWidth="3"
  >
    <animate
      attributeName="x"
      values="10;15;10"
      dur="3s"
      repeatCount="indefinite"
    />
  </rect>
  <line
    x1="10"
    y1="75"
    x2="80"
    y2="75"
    stroke="#ffffff"
    strokeWidth="3"
  >
    <animate
      attributeName="stroke-dasharray"
      values="0,200;200,0;0,200"
      dur="4s"
      repeatCount="indefinite"
    />
  </line>

  {/* Mobile */}
  <rect
    x="100"
    y="10"
    width="30"
    height="60"
    rx="5"
    fill="transparent"
    stroke="#ffffff"
    strokeWidth="3"
  >
    <animate
      attributeName="y"
      values="10;15;10"
      dur="2.5s"
      repeatCount="indefinite"
    />
  </rect>
  <circle cx="115" cy="70" r="3" fill="#f9c23c" />
</svg>




            </div>
            <h5 className="title-1">
              Custom, responsive design
            </h5>
            <p className="disc">
              We build websites using modern frameworks and design principles that adapt across devices – from desktop to mobile – ensuring intuitive navigation, faster load times, and enhanced satisfaction.
            </p>
          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">

      <svg
        width="80"
        height="80"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="50"
          cy="50"
          r="30"
          stroke="#ffffff"
          strokeWidth="5"
          fill="none"
          strokeDasharray="188"
          strokeDashoffset="188"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="188;0;188"
            dur="4s"
            repeatCount="indefinite"
          />
        </circle>
        <polygon points="45,35 65,50 45,65" fill="#ffffff">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1;1.3;1"
            dur="2s"
            repeatCount="indefinite"
          />
        </polygon>
      </svg>



            </div>
            <h5 className="title-1">
              SEO-friendly structure & speed
            </h5>
            <p className="disc">
              Every website is optimized for clean URL structure, logical hierarchy, fast loading speeds, and mobile-first usability - all key factors that help improve search rankings and user engagement.
            </p>

          </div>
          {/* single service area end */}
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">


      <svg
        width="80"
        height="80"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="20" y="20" width="20" height="20" fill="#ffffff">
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0;40 0;0 0"
            dur="3s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="60" y="20" width="20" height="20" fill="#ffffff">
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0;-40 0;0 0"
            dur="3s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="40" y="60" width="20" height="20" fill="#ffffff">
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 50 70;360 50 70;0 50 70"
            dur="4s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>



            </div>
            <h5 className="title-1">
              Scalable development & clean code
            </h5>
            <p className="disc">
              Whether it's a simple business site or a dynamic platform, our development practices focus on maintainability, scalability, and performance - ensuring your website grows seamlessly with your business.
            </p>
          </div>
          {/* single service area end */}
        </div>
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
          {/* single service area start */}
          <div className="single-service-style-seven">
            <div className="icon">


      <svg
        width="80"
        height="80"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="15"
          y="25"
          width="70"
          height="50"
          rx="6"
          fill="transparent"
          stroke="#ffffff"
          strokeWidth="3"
        />
        <line x1="25" y1="40" x2="75" y2="40" stroke="#fff" strokeWidth="3">
          <animate
            attributeName="x2"
            values="25;75;25"
            dur="3s"
            repeatCount="indefinite"
          />
        </line>
        <line x1="25" y1="55" x2="65" y2="55" stroke="#fff" strokeWidth="3">
          <animate
            attributeName="x2"
            values="25;65;25"
            dur="2.5s"
            repeatCount="indefinite"
          />
        </line>
      </svg>



            </div>
            <h5 className="title-1">
              Content-first design approach
            </h5>
            <p className="disc">
              Pages are built with relevant content, semantic structure, helping users and search engines understand offerings. Internal linking and optimized headers ensure crawlability and relevance.
            </p>
          </div>
          {/* single service area end */}
        </div>
      </div>
    </div>
  </div>
  {/* service area ends */}




{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  



</>    


  );
};

export default WebDesignDevelopment;
